import $ from 'jquery'
import Swal from 'sweetalert2'

export const pdfPrint = (i18n) => {
  $(document).on('click', '.cc-make-pdf', function (e) {
    e.preventDefault()
    e.stopPropagation()

    const $this = $(this)

    $.ajax({
      url: i18n.ajaxUrl,
      type: 'POST',
      xhrFields: {
        responseType: 'blob',
      },
      data: {
        order_id: $this.attr('data-order-id') * 1,
        item_id: $this.attr('data-item-id') * 1,
        _ajax_nonce: i18n.nonce,
        action: 'cc_get_order_pdf',
      },
      beforeSend: () => {
        Swal.fire({
          icon: 'warning',
          title: i18n.pdfCreating,
          html: i18n.pdfWait,
          timerProgressBar: true,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading()
          },
        })
      },
      success: function (data) {
        const button = document.createElement('a')
        const blob = new Blob([data], { type: 'application/pdf' })

        button.href = URL.createObjectURL(blob)
        button.download = $this.attr('data-title')
        button.click()
        button.remove()
        Swal.close()
      },
      error: function () {
        Swal.close()
      },
    })
  })
}
